import localStore from '@theme/local-store'
import { Component } from '@theme/component'

/**
 * <vehicle-summary>
 * Muestra el vehículo/marca seleccionados leyendo desde localStore.
 * Se actualiza cuando cambian los eventos: `vehicle:changed` y `vehicle-make:changed`.
 */
class VehicleSummary extends Component {
  constructor() {
    super()
    /** @type {(e: CustomEvent) => void} */
    this._onVehicleChanged = this._onVehicleChanged.bind(this)
    /** @type {(e: CustomEvent) => void} */
    this._onMakeChanged = this._onMakeChanged.bind(this)
  }

  connectedCallback() {
    super.connectedCallback?.()
    // Estructura mínima interna si no existe
    if (!this.querySelector('[ref="value"]')) {
      this.innerHTML =
        '<strong class="vehicle-summary__value" ref="value"></strong>'
    }

    requestAnimationFrame(() => this._render())
    document.addEventListener('vehicle:changed', this._onVehicleChanged)
    document.addEventListener('vehicle-make:changed', this._onMakeChanged)
  }

  disconnectedCallback() {
    document.removeEventListener('vehicle:changed', this._onVehicleChanged)
    document.removeEventListener('vehicle-make:changed', this._onMakeChanged)
    super.disconnectedCallback?.()
  }

  /** @param {CustomEvent} _e */
  _onVehicleChanged(_e) {
    this._render()
  }

  /** @param {CustomEvent} _e */
  _onMakeChanged(_e) {
    this._render()
  }

  _render() {
    const el = /** @type {HTMLElement|null} */ (
      this.querySelector('[ref="value"]')
    )
    if (!el) return

    const { make, label } = this._getState()
    // Mostrar como: "Make - Vehicle"
    const parts = []
    if (make) parts.push(this._capitalizeHandle(make))
    if (label) parts.push(label)
    el.textContent = parts.join(' - ')
  }

  _getState() {
    // Lee la selección de vehículo; puede venir como objeto o string JSON
    let stored = localStore.get('vehicle', null)
    if (typeof stored === 'string') {
      try {
        stored = JSON.parse(stored)
      } catch (_) {}
    }

    /** @type {{ make?: string, label?: string } | null} */
    const v = stored && typeof stored === 'object' ? stored : null

    // Fallback a la marca guardada si no hay vehículo seleccionado
    const make = v?.make || localStore.get('vehicle_make', '') || ''
    const label = (v?.label && String(v.label).trim()) || ''

    return { make, label }
  }

  _capitalizeHandle(handle) {
    if (!handle) return ''
    return String(handle)
      .split('-')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ')
  }
}

if (!customElements.get('vehicle-summary')) {
  customElements.define('vehicle-summary', VehicleSummary)
}
